import { gofor } from '@fiverr-private/futile';
import { getContext } from '@fiverr-private/fiverr_context';
import * as Error from '../../utils/error';
import * as DataViewErrors from '../../errors/dataView';
import mapBodyToEntity from '../../utils/mapBodyToEntity';

const URL = '/collaboration/dataview';

const getFetchUrl = (filerrIds, userId, collaboratorId, pdfNoCollaboration = false) => {
    let dataViewUrl = `${URL}?current_collaborator_identifier=${userId||collaboratorId}`;

    if (pdfNoCollaboration) {
        const { userId } = getContext();
        return `${URL}?current_collaborator_identifier=${userId}&show_pdf_viewer=true`;
    }
    filerrIds.forEach((filerrId) => {
        dataViewUrl += `&filerr_ids[]=${filerrId}`;
    });

    return dataViewUrl;
};

/**
 * Delay with a promise
 * @param {number} n the delay value in ms
 * @returns {Promise}
 */
const delay = (n) => new Promise((resolve) =>
    setTimeout(() => resolve(), n)
);

export const fetch = (filerrIds, userId, collaboratorId, pdfNoCollaboration = false) =>
    Promise.resolve().then(() =>
        getFetchUrl(filerrIds, userId, collaboratorId, pdfNoCollaboration)
    ).then((url) =>
        gofor(url)
    ).then((response) => {
        if (response.status === 401) {
            throw Error.create(
                'Collaborator was removed and cannot see dataview',
                DataViewErrors.DATAVIEW_APIS_FETCH_COLLABORATOR_REMOVED,
                { filerrIds, userId, collaboratorId }
            );
        }

        if (response.status === 403) {
            throw Error.create(
                'Files not found',
                DataViewErrors.DATAVIEW_APIS_FETCH_FILES_NOT_FOUND,
                { filerrIds, userId, collaboratorId }
            );
        }

        if (response.status === 404) {
            throw Error.create(
                'DataView not found',
                DataViewErrors.DATAVIEW_APIS_FETCH_NOT_FOUND,
                { filerrIds, userId, collaboratorId }
            );
        }

        if (!response.ok) {
            throw Error.create(
                `Cannot fetch dataview, unexpected error, status: ${response.status}`,
                DataViewErrors.DATAVIEW_APIS_FETCH_BAD_SERVER_STATUS,
                { filerrIds, userId, collaboratorId }
            );
        }

        return response.json();
    }).then((body) => ({
        comments: mapBodyToEntity(body, 'comments'),
        collaborators: mapBodyToEntity(body, 'collaborators'),
        groups: mapBodyToEntity(body, 'groups'),
        files: mapBodyToEntity(body, 'files'),
        filerrs: mapBodyToEntity(body, 'filerrs'),
        shareableLinks: mapBodyToEntity(body, 'shareable_links'),
        showPdfViewer: body.show_pdf_viewer
    })).then((data) => {
        if (data.groups && Object.keys(data.groups).length > 2) {
            throw Error.create(
                'DataView contains more than 2 groups',
                DataViewErrors.DATAVIEW_APIS_FETCH_INVALID_GROUPS_COUNT,
                { filerrIds, userId, collaboratorId }
            );
        }

        return data;
    }).catch((error) => {
        if (!error.code) {
            error.code = DataViewErrors.DATAVIEW_APIS_FETCH_UNEXPECTED;
            error.details = {
                payload: { filerrIds, userId, collaboratorId }
            };
        }

        throw error;
    }).catch((error) => {
        if (error.code === DataViewErrors.DATAVIEW_APIS_FETCH_FILES_NOT_FOUND) {
            return delay(200).then(() => fetch(filerrIds, userId, collaboratorId));
        }

        throw error;
    });
